"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TENANT_FIELD_META = void 0;
// Tenant fields tracked by the Update vs Correction diff. Used by the edit
// dialog and the history timeline so they show the same set of fields in the
// same order.
var TENANT_FIELD_META = [
    { key: "name", label: "Tenant / Company Name", group: "Basic" },
    { key: "tradingAsName", label: "Trading As Name", group: "Basic" },
    { key: "partyType", label: "Party Type", group: "Basic" },
    { key: "registrationNumber", label: "Registration Number", group: "Basic" },
    { key: "taxNumber", label: "Tax Number", group: "Basic" },
    { key: "tenantCode", label: "Tenant Code", group: "Basic" },
    { key: "isJuristicPerson", label: "Juristic Person", group: "Basic" },
    { key: "isActive", label: "Active", group: "Basic" },
    { key: "address", label: "Address", group: "Address" },
    { key: "accountCode", label: "Account Code", group: "Financial" },
    { key: "sameAccountCodeAllBuildings", label: "Same Account Code Across Buildings", group: "Financial" },
    { key: "taxType", label: "Tax Type", group: "Financial" },
    { key: "contactPersons", label: "Contact Persons", group: "Contacts" },
    { key: "billingContacts", label: "Billing Contacts", group: "Contacts" },
];
exports.TENANT_FIELD_META = TENANT_FIELD_META;
